<div class="help">
  <header class="help__header">
    <div class="help__header-content">
      <h1 class="help__heading" [class.center]="invalidQuoteEmail">{{ pageHeadingText }}</h1>
      <h3 *ngIf="clientHasAgent && draftApp" class="help__subheading">
        Your financial professional will provide you with a link to your application when it is ready. Please contact
        them if you have not yet received a link.
      </h3>
      <h3 *ngIf="clientHasAgent && invalidQuoteEmail" class="help__subheading">
        Please contact your financial professional.
      </h3>
    </div>
  </header>
  <div class="help__section-container">
    <section
      *ngIf="clientHasAgent"
      class="help__section help__section--contact-agent"
      [ngClass]="{ help__divider: !!helpContactInfo && helpContactInfo.length < 2 }"
    >
      <div class="help__section-header">
        <h3 class="help__section-subheading">Questions about life insurance?</h3>
        <h2 class="help__section-heading">Contact your {{ advisorDescriptiveNoun }}</h2>
        <div class="help__section-divider"></div>
      </div>
      <div class="list-group" [ngClass]="{ 'list-group--contact': !!helpContactInfo && helpContactInfo.length > 1 }">
        <div *ngFor="let info of helpContactInfo" class="list-group__item">
          <img class="list-group__icon" src="/img/components/help/advisor.svg" />
          <div class="list-group__info">
            <div *ngIf="!!info.policies" class="list-group__space">
              <span *ngIf="info.policies.length === 1">For policy</span>
              <span *ngIf="info.policies.length > 1">For policies</span>
              <span *ngFor="let policy of info.policies">
                <span
                  *ngIf="
                    info.policies.length > 1 &&
                    policy.policyNumber === info.policies[info.policies.length - 1].policyNumber
                  "
                  >and
                </span>
                <a [routerLink]="['/account-center-detailed-view']" [queryParams]="getQueryParams(policy)">{{
                  policy.policyNumber
                }}</a
                ><span *ngIf="policy === info.policies[info.policies.length - 1]">:</span
                ><span
                  *ngIf="
                    info.policies.length > 2 &&
                    policy.policyNumber !== info.policies[info.policies.length - 1].policyNumber
                  "
                  >,
                </span>
              </span>
            </div>
            <h3 class="list-group__title">{{ info.name }}</h3>
            <p class="list-group__heading">
              <a href="mailto:{{ info.email }}">{{ info.email }}</a>
            </p>
            <p class="list-group__body">
              <a href="tel:{{ info.phoneLink }}">{{ info.phone }}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="help__section help__section--contact-support">
      <div class="help__section-header">
        <h3 class="help__section-subheading">{{ supportHeadingText }}</h3>
        <h2 class="help__section-heading">Contact Coverpath support</h2>
        <div class="help__section-divider"></div>
      </div>
      <div class="list-group" [ngClass]="{ 'list-group--compact': clientHasAgent }">
        <div class="list-group__item">
          <img class="list-group__icon" src="/img/components/help/email.svg" />
          <div class="list-group__info">
            <h4 class="list-group__heading">
              <a href="mailto:DigitalCustomerSupport@massmutual.com">DigitalCustomerSupport@massmutual.com</a>
            </h4>
            <p class="list-group__body">We will reply within one business day</p>
          </div>
        </div>
        <div class="list-group__item">
          <img class="list-group__icon" src="/img/components/help/phone.svg" />
          <div class="list-group__info">
            <h4 class="list-group__heading"><a href="tel:1+8666187797">1 (866) 618-7797</a></h4>
            <p class="list-group__body">8am-6pm EST, Monday-Friday</p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <genesys-constellation [participantData]="genesysParticipantData"> </genesys-constellation>
</div>
